import React from "react";
import { safeLocalFormat } from "../../../utilities/functions";

const StartShiftDate = ({ row }) => {
  return <div>{row.startShift ? safeLocalFormat(row?.startShift) : "-"}</div>;
};

export default StartShiftDate;
